// Events for cart genius Banner
const CartGeniusBanner = function () {
    function viewCartGeniusDetails(target, errorBoxId, isFromMenu = false) {
        // Not normal if the user tries to view Cart genius while the store locator is open
        if (ServiceTimeslot.isModalServiceAndTimeslotOpen()) {
            return;
        }
        if (isInWebview() && !isAuthenticated) {
            // send event to redirect to connection page in the App
            sendUserNotAuthenticatedEventToDevice();
            return;
        }

        window['isCartGeniusOpened'] = true;

        // create CART_GENIUS_PRODUCTS_LIST in session
        if (!sessionStorage.getItem(CartGenius.CART_GENIUS_PRODUCTS_LIST)) {
            sessionStorage.setItem(CartGenius.CART_GENIUS_PRODUCTS_LIST, JSON.stringify([]));
        }

        if (!sessionStorage.getItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST)) {
            sessionStorage.setItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST, JSON.stringify([]));
        }

        let overlayEnabled = productOverlayEnabled !== 'undefined' && productOverlayEnabled;
        let isMyFavouritePage = window.location.pathname === myFavouritesUrl;
        let $cartgeniusBannerContainer = $('.cartGeniusContainer');

        // to activate spinning animation while making api calls for overlay or timeslots side panel
        $cartgeniusBannerContainer.addClass('item-addToCart');

        if (!window['storeId']) {
            if (!isInWebview() && overlayEnabled && !isMyFavouritePage) {
                showOverlayServiceBox.createCart($cartgeniusBannerContainer, errorBoxId);
            } else {
                ServiceTimeslot.openServiceAndTimeslot.bind($cartgeniusBannerContainer)(undefined, undefined, errorBoxId);
            }
        } else if ($cartgeniusBannerContainer.length > 0 && !isFromMenu && overlayEnabled && showOverlay(isMyFavouritePage)) {
            showOverlayServiceBox.findServiceByPostalCode(undefined, $cartgeniusBannerContainer, errorBoxId, false);
        } else {
            // Open Cart genius side panel
            openCartGeniusDetails();
        }

        $cartgeniusBannerContainer.remove('item-addToCart');
    }


    function openCartGeniusDetails() {
        CartGenius.getCartGenius();
        window['isCartGeniusOpened'] = false;
    }

    function closeCartGeniusDetails() {
        window['isCartGeniusOpened'] = false;
    }

    function openServiceAndTimeslots(target, errorBoxId) {
        window['isCartGeniusOpened'] = true;
        $('.data-origin-GA').data('origin-ga', 'cart genius');
        ServiceTimeslot.openServiceAndTimeslot.bind(target)(undefined, undefined, errorBoxId);
    }

    function cartGeniusSignInOrSignUp(event) {
        if (isInWebview() && !isAuthenticated) {
            sendUserNotAuthenticatedEventToDevice();
        } else {
            submitLoginSignupForm(event);
        }
    }

    function showOverlay(isMyFavouritePage) {
        hideOverlayNbClick = parseInt(TINK.getCookie('hide_product_overlay_add_click'));
        let hideOverlayCookie = TINK.getCookie('hide_product_overlay');
        let impulsivePurchasesPanelOpened = $('#miniCartModal.remodal-is-opened').length > 0 && !$('.mini-cart-spontaneous-purchase').hasClass('hide');
        let serviceTypeExpressDelivery = serviceType && serviceType == 'cornershop_home_delivery';
        let showOverlay = ((typeof hideOverlayCookie == 'undefined' || !hideOverlayCookie) || (restCountAddToCart) || (currentNbAddToCart == hideOverlayNbClick))
            && typeof cartWithoutTimeslot != 'undefined' && cartWithoutTimeslot
            && !serviceTypeExpressDelivery
            && !isMyFavouritePage
            && !isInWebview()
            && !impulsivePurchasesPanelOpened;

        return showOverlay;
    }

    //****************************************************************
    // Async loading : cart genius banner
    //****************************************************************

    function buildAsyncDataUrl($target = $('#cartGeniusContent'), skusToRemove, isConflictError = false, forceCartGeniusCacheInvalidation = false) {
        $target.attr('data-load-url', function (i, currentUrl) {
            const url = new URL(currentUrl, window.location.origin);
            url.searchParams.set('skusToRemove', skusToRemove);
            url.searchParams.set('isConflictError', isConflictError.toString());
            url.searchParams.set('forceCartGeniusCacheInvalidation', forceCartGeniusCacheInvalidation.toString());
            return url.toString();
        });
    }

    // Callback function to be executed after the asynchronous loading of the Cart Genius banner is complete.
    function afterAsyncCartGeniusLoadCallback() {
        $('.product-loader').addClass('hidden');
        // After reload, we automatically open Cart Genius
        if (sessionStorage.getItem('triggerOpeningCartGeniusAfterReload') && window['storeId']) {
            CartGeniusBanner.openCartGeniusDetails();
            sessionStorage.removeItem('triggerOpeningCartGeniusAfterReload');
        }

        let geniusHasContent = $('#cartGeniusContent');
        let hasUsedGenius = localStorage.getItem("hasUsedGenius") === 'true';
        let $tooltip = $('.cartGeniusTooltip');
        let $plpGridList = $('.plpGridList');

        if (hasUsedGenius) {
            $tooltip.remove();
            $plpGridList.removeClass('has-tooltip-tile');
        } else {
            $tooltip.removeClass('hide');
            $plpGridList.addClass('has-tooltip-tile');
        }

        if ($plpGridList.length) {
            if (flyerCartGeniusGlobalEnabled && geniusHasContent.length === 0) {
                $plpGridList.removeClass('has-genius-tile');
                if (typeof isFlyerPageRequest !== "undefined" && isFlyerPageRequest) {
                    catalogueFlyerGrid.positionMarketingTiles();
                    $('#cartGeniusPlaceholder').hide();
                } else {
                    catalogProductGrid.positionMarketingTiles();
                    $('#cartGeniusPlaceholder').hide();
                }
            }
        }
        if (typeof isFlyerPageRequest !== "undefined") {
            if (!isFlyerPageRequest) {
                _push_custom_event_to_GA4('cart_genius_view', 'description', 'tile | viewed on plp');
            }
        } else {
            _push_custom_event_to_GA4('cart_genius_view', 'description', 'tile | viewed on landing page');
        }
        if ($('#cartGeniusContent .cartGenius--items .genius_grid .icon-genius').length === 0) {
            $('#cartGeniusContent').hide();
            if ($('#cartGeniusPlaceholder').length > 0) {
                $('#cartGeniusPlaceholder').hide();
            }
        } else {
            $('#cartGeniusContent').show();
        }
    }

    function asyncLoadCartGeniusCallback($target = $('#cart-genius-main'), isConflictError = false) {
        let cartGeniusProductsToRemove = [];
        let forceCartGeniusCacheInvalidation = false;

        if (sessionStorage.getItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST) && sessionStorage.getItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST).length > 0) {
            let productsFromSession = JSON.parse(sessionStorage.getItem(CartGenius.CART_GENIUS_USER_REMOVED_SKUS_LIST));
            cartGeniusProductsToRemove = productsFromSession || [];
        }

        if (sessionStorage.getItem('forceCartGeniusCacheInvalidation')) {
            forceCartGeniusCacheInvalidation = sessionStorage.getItem('forceCartGeniusCacheInvalidation');
            sessionStorage.removeItem('forceCartGeniusCacheInvalidation')
        }

        buildAsyncDataUrl($target, cartGeniusProductsToRemove.join(','), isConflictError, forceCartGeniusCacheInvalidation);
        // Load cart genius banner

        $target.asyncLoad(afterAsyncCartGeniusLoadCallback);
    }

    //****************************************************************
    // Expose for binding
    //****************************************************************

    return {
        viewCartGeniusDetails: viewCartGeniusDetails,
        openCartGeniusDetails: openCartGeniusDetails,
        asyncLoadCartGeniusCallback: asyncLoadCartGeniusCallback,
        openServiceAndTimeslots: openServiceAndTimeslots,
        cartGeniusSignInOrSignUp: cartGeniusSignInOrSignUp
    };
}();

$(document).on('click', '#cartGeniusBannerClose', function () {
    _push_custom_event_to_GA4('cart_genius_click', 'description', 'tile | x - hide for the rest of the session');
    document.cookie = 'cart_genius_banner_closed=true; path=/';
    $('#cartGeniusContent').remove();
});

$(document).on('click', '.nav__left-col .header-nav--links li a.viewCartGenius.active.card-genius-new', function () {
    _push_custom_event_to_GA4('cart_genius_click', 'description', 'big menu button | website');
});